<template>
  <DialogBaseBlue :show="showDialogMADTemplate" @on-close="closeDialog"
                  :title="$t('MADTemplate.description') | capitalize">
    <template v-slot:action v-if="isHasManageRole">
      <div class="btn-create-new" @click="openDialogCreateMADTemplate">
        <v-icon size="16" color="white">mdi-plus-circle</v-icon>
        <span class="btn-text">{{ $t('createNew') | capitalize }}</span>
      </div>
    </template>
    <template v-slot:content>
      <div class="content-container">
        <div class="filter-box">
          <div class="search-template">
            <v-icon size="20" class="search-template-icon">mdi-magnify</v-icon>
            <input v-model='search' type="text" autocomplete="nope" :placeholder="$t('search') | capitalize"/>
          </div>
        </div>
        <div class="list-template scroll-thin">
          <TemplateLoading v-if="loading"/>
          <div v-else class="template-item" v-for="(item, idx) of listTemplateFilters" v-bind:key="item._id" :style="idx===0 ? 'border-top: 1px solid #D0D4E2': ''" v-on:click="onUseTemplate(item)">
            <div class="template-content">
              <ul>
                <li class="content-title">
                  {{ item.title }}
                </li>
                <li class="content-desc">
                  {{ item.content }}
                </li>
              </ul>
            </div>
            <div class="template-action">
              <v-btn v-if="isHasManageRole" flat icon class="btn-edit"
                     v-on:click.stop.prevent="openDialogUpdateMADTemplate(item)">
                <img src="/icon/pencil-line.svg" alt=""/>
              </v-btn>
              <v-btn v-if="isHasManageRole" flat icon class="btn-delete"
                     v-on:click.stop.prevent="deleteMADTemplate(item)">
                <img src="/icon/delete.svg" alt=""/>
              </v-btn>
            </div>
          </div>
        </div>
      </div>
    </template>
  </DialogBaseBlue>
</template>
<script>
import DialogBaseBlue from "components/dialog/base/DialogBaseBlue";
import {mapActions, mapState} from "vuex";
import TemplateLoading from "components/custom/TemplateLoading";
import utils from "@/services/utils";
import _ from "lodash";

export default {
  name: "DialogMADTemplate",
  components: {TemplateLoading, DialogBaseBlue},
  data() {
    return {
      search: "",
      hasManageRole: false,
    }
  },
  mounted() {
    this.getAllTemplate()
  },
  computed: {
    ...mapState('dialog', ['showDialogMADTemplate']),
    ...mapState('madTemplate', ['listTemplate', 'loading']),
    ...mapState(['user', 'token', 'bot', 'botStaffList']),
    listTemplateFilters: function () {
      let key = utils.removeVietnameseTones(this.search.trim().toLowerCase());
      let list = this.listTemplate;
      //Filter search
      if (key) {
        list = _.filter(list, (item) => {
          let title = utils.removeVietnameseTones(item.title.toLowerCase())
          return title.includes(key)
        })
      }
      return list
    },
    isHasManageRole() {
      let botStaff = _.find(this.botStaffList, item => item.bot_code === this.bot.code);
      if (!botStaff || !botStaff.staffs || botStaff.staffs.length === 0) {
        return false;
      }
      botStaff = botStaff.staffs;
      let staff = _.find(botStaff, item => item.id === this.user.id);
      if (!staff) {
        return false;
      }
      return [10,9,5].includes(staff.role_level);
    }
  },
  methods: {
    ...mapActions('dialog', ['closeDialogMADTemplate', 'openDialogCreateMADTemplate', 'openDialogUpdateMADTemplate']),
    ...mapActions('madTemplate', ['getAllTemplate', "deleteMADTemplate"]),
    onUseTemplate(template) {
      this.$EventBus.$emit(this.$EventBusType.ON_USE_MAD_TEMPLATE, template)
    },
    closeDialog() {
      this.search = "";
      this.closeDialogMADTemplate()
    }
  },
  watch: {
    '$route.params.bot_code': {
      handler: function() {
        this.getAllTemplate()
      },
    },
  },
}
</script>

<style scoped lang="scss">
@import "components/style/dialog-mad-template";
</style>
